<script setup lang="ts">
import { NPopconfirm } from 'naive-ui'

// The Live CV header actions: queue a new generated version, and approve
// the selected draft (shown only while a draft is selected). The parent
// owns the stores; this only reports the clicks.
defineProps<{
  generating: boolean
  triggering: boolean
  approveVersionId: number | null
  approving: boolean
}>()

const emit = defineEmits<{ generate: []; approve: [] }>()
</script>

<template>
  <div class="flex flex-wrap items-center gap-2" data-testid="cv-header-actions">
    <button
      type="button"
      class="inline-flex min-h-11 items-center gap-2 rounded-[10px] border border-border-control px-4 font-medium text-ink hover:bg-surface-hover disabled:cursor-not-allowed disabled:opacity-60 sm:min-h-10"
      :disabled="generating || triggering"
      :aria-busy="generating || triggering"
      data-testid="cv-generate"
      @click="emit('generate')"
    >
      <span
        v-if="generating || triggering"
        class="h-3.5 w-3.5 animate-spin rounded-full border-2 border-ink-faint border-t-transparent"
        aria-hidden="true"
      />
      {{ generating ? 'Generating…' : 'Generate new version' }}
    </button>
    <NPopconfirm
      v-if="approveVersionId !== null"
      positive-text="Approve"
      negative-text="Cancel"
      @positive-click="emit('approve')"
    >
      <template #trigger>
        <button
          type="button"
          class="inline-flex min-h-11 items-center gap-2 rounded-[10px] bg-life px-4 font-semibold text-surface-bg hover:opacity-90 disabled:opacity-60 sm:min-h-10"
          :disabled="approving"
          :aria-busy="approving"
          data-testid="cv-approve"
        >
          Approve v{{ approveVersionId }}
        </button>
      </template>
      Approve this version? It replaces the currently approved one. Unsaved edits are not included.
    </NPopconfirm>
  </div>
</template>
